import { connect } from "react-redux";
import { hideModal } from "../../../../actions/modals";
import ImageControlModalContainer from "./ImageControlModalContainer";
import { putNormalizedEntities } from "../../../../helpers";

const mapStateToProps = (state, props) => {
    return {
        isVisible: true,
        blockId: props.blockId,
        manualImageControl: props.manualImageControl,
        ceremonyId: props.ceremonyId,
    };
};

const MapDispatchToProps = (dispatch, props) => {
    return {
        updateStoreEntities: (entities) => {
            putNormalizedEntities(dispatch, entities);
        },
        hideModal: () => dispatch(hideModal()),
    };
};

export default connect(
    mapStateToProps,
    MapDispatchToProps
)(ImageControlModalContainer);
